import { createContext, type Context } from 'react';

import { useRequiredContext } from '@/hooks';

import type {
  ClusterCapabilityId,
  SiteDeviceServicesAvailability,
} from './availableServices.config.ts';

type AvailableServicesContextType = {
  isLoading: boolean;
  isFetching: boolean;
  isFetched: boolean;
  isSuccess: boolean;
  isError: boolean;
  /**
   * Pod-derived capability ids on the cluster. `null` while pod list is still unknown (pending).
   * On services API error or empty pod list, matches legacy hooks: full set (assume all capabilities).
   */
  clusterAvailableServiceSet: ReadonlySet<ClusterCapabilityId> | null;
  /** Device-config add-device picker rows from `clusterAvailableServiceSet`. */
  deviceConfigServicesAvailability: SiteDeviceServicesAvailability;
};

export const AvailableServicesContext: Context<AvailableServicesContextType | undefined> =
  createContext<AvailableServicesContextType | undefined>(undefined);

export const useAvailableServicesContext = (): AvailableServicesContextType =>
  useRequiredContext({
    context: AvailableServicesContext,
    hookName: 'useAvailableServicesContext',
    providerName: 'AvailableServicesProvider',
  });
